import { Price, Text } from '@kanda-libs/ks-design-library';
import { FinanceRate } from '@kanda-libs/ks-frontend-services';
import useRate from './useRate';

interface RateProps {
  apr: string;
  rates: FinanceRate[];
  isLoading: boolean;
}

const Rate: React.FunctionComponent<RateProps> = function ({
  apr,
  rates,
  isLoading,
}) {
  const { aprLabel, maxBorrow, termLabel, classNames, onClick } = useRate(
    apr,
    rates,
    isLoading,
  );
  return (
    <button
      type="button"
      className={classNames.container}
      aria-label={`apr-${apr}`}
      onClick={onClick}
    >
      <div className={classNames.wrapper}>
        <Text
          text={aprLabel}
          className={classNames.rate}
          isLoading={isLoading}
        />
        <div className={classNames.separator} />
        <div className="flex flex-col mx-auto">
          <Text
            text="Max. borrow"
            className="text-11-20-up text-neutral-600"
            isLoading={isLoading}
          />
          <Price
            amount={maxBorrow}
            poundsClassName="text-13-14 text-lavender-200"
            centsClassName="text-13-14 text-lavender-200"
            isLoading={isLoading}
          />
        </div>
        <div className="flex flex-col mx-auto">
          <Text
            text="Max. term"
            className="text-11-20-up text-neutral-600"
            isLoading={isLoading}
          />
          <Text
            text={termLabel}
            className="text-13-14 text-lavender-200"
            isLoading={isLoading}
          />
        </div>
      </div>
    </button>
  );
};

export default Rate;
